import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  className?: string;
}

export function AddArticleButton(props: Props) {
  const push = useNavigate();
  const { t } = useTranslation();
  const { className } = props;

  return (
    <div className={className}>
      <Button type="primary" onClick={() => push(`/admin/articles/add`)}>
        {t('articles.add')}
      </Button>
    </div>
  );
}
